module.exports = __webpack_public_path__ + "static/media/users.969fac49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/users.svg
// module id = 863
// module chunks = 0